const initialState = {
  featuredBusinessProperties: [],
  featuredBusinessProperty: null,
  total: 0,
  loading: false,
  error: null,
};

export const featuredBusinessPropertyReducer = (state = initialState, action) => {
  switch (action.type) {

    // Add
    case "FEATURED_BUSINESS_PROPERTY_ADD_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FEATURED_BUSINESS_PROPERTY_ADD_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };

    case "FEATURED_BUSINESS_PROPERTY_ADD_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update
    case "FEATURED_BUSINESS_PROPERTY_UPDATE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FEATURED_BUSINESS_PROPERTY_UPDATE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };

    case "FEATURED_BUSINESS_PROPERTY_UPDATE_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // List
    case "FEATURED_BUSINESS_PROPERTY_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FEATURED_BUSINESS_PROPERTY_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        featuredBusinessProperties: action.payload.data || [],
        total: action.payload.total || 0,
        error: null,
      };

    case "FEATURED_BUSINESS_PROPERTY_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // View
    case "FEATURED_BUSINESS_PROPERTY_VIEW_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FEATURED_BUSINESS_PROPERTY_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        featuredBusinessProperty: action.payload.data || null,
        error: null,
      };

    case "FEATURED_BUSINESS_PROPERTY_VIEW_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        featuredBusinessProperty: null,
      };

    case "CLEAR_FEATURED_BUSINESS_PROPERTY_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};